/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import GetPayHistoryActionBox from '../ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import './tables_styles.css';
import EmployeeNamePic from '../EmployeeNamePic/EmployeeNamePic';
import SwapShiftModalARController from '../../Modals/ActionRequiredModals/SwapShiftModalAR/SwapShiftModalARController';
import { arabicDataGrid, baseDateFormatting } from '../../helper';
import { useTranslate } from '../../../hooks';
import { DateField } from '../../../components';

interface Propval {
  trans: any;
}
const SwapShift = ({ trans }: Propval) => {
  const [openModal, setOpenModal] = useState(false);

  const tableColumns: any = [
    {
      field: 'appliedOn',
      headerName: trans('Applied On'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <DateField value={params?.row?.appliedOn} format={baseDateFormatting} />
      ),
    },
    {
      field: 'requestBy',
      headerName: trans('Request By'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: () => {
        return <EmployeeNamePic name="Khanzada Hanzla" picture="" />;
      },
    },
    {
      field: 'swapTo',
      headerName: trans('Swap To'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: () => {
        return <EmployeeNamePic name="Amelia Russel" picture="" />;
      },
    },
    {
      field: 'status',
      headerName: trans('Status'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },

    {
      field: 'action',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      headerAlign: 'center',
      align: 'center',
      renderCell: () => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              setOpenModal(true);
            }}
          />
        );
      },

      width: 200,
      height: 70,
    },
  ];

  const row_data = [{ id: 1, appliedOn: '30/07/2022', status: 'Pending' }];

  const { isRTL } = useTranslate();

  return (
    <>
      <Box
        className="ar_table"
        sx={{
          '& .header': {
            backgroundColor: '#F5F5F5',
          },

          width: '100%',
          marginTop: '2em',
        }}
      >
        <DataGrid
          sx={{
            color: '#081735',
            font: 'normal normal normal 14px/24px Lato;',
          }}
          autoHeight
          disableExtendRowFullWidth
          localeText={isRTL ? arabicDataGrid : undefined}
          disableSelectionOnClick
          rows={row_data}
          columns={tableColumns}
          componentsProps={{
            pagination: {
              labelRowsPerPage: trans('Rows per page'),
            },
          }}
        />
      </Box>
      {openModal && (
        <SwapShiftModalARController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
        />
      )}
    </>
  );
};

export default SwapShift;
